import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AnchorBox } from "@vfit/shared/atoms";
import { Children } from "react";
import { AnchorsContainer, MainContainer, Title } from "./AnchorsList.style";
var AnchorsList = function(param) {
    var title = param.title, _isDarkMode = param.isDarkMode, isDarkMode = _isDarkMode === void 0 ? false : _isDarkMode, anchors = param.anchors;
    var renderAnchors = function() {
        return Children.toArray(anchors === null || anchors === void 0 ? void 0 : anchors.map(function(el) {
            /*#__PURE__*/ return _jsx(AnchorBox, {
                isDarkMode: (el === null || el === void 0 ? void 0 : el.isDarkMode) || false,
                anchorLabel: el === null || el === void 0 ? void 0 : el.anchorLabel,
                anchorLink: el === null || el === void 0 ? void 0 : el.anchorLink
            });
        }));
    };
    return /*#__PURE__*/ _jsxs(MainContainer, {
        children: [
            /*#__PURE__*/ _jsx(Title, {
                darkMode: isDarkMode,
                children: title
            }),
            /*#__PURE__*/ _jsx(AnchorsContainer, {
                children: renderAnchors()
            })
        ]
    });
};
export default AnchorsList;
